export const useUseColorModeSettings = () => {
  
  const lightModeIcon = "i-lucide-sun-medium";
  const darkModeIcon = "i-lucide-moon";
  const colorMode = useColorMode();
  const colorModeIcon = ref(getColorModeIcon());

  
  function toggleColorMode() {
    colorMode.value = colorMode.value === "light" ? "dark" : "light";
    colorModeIcon.value =getColorModeIcon();
    colorMode.preference = colorMode.value; //make sure stored in local storage
  }
  function getColorModeIcon(){
    return colorMode.value === "light" ? lightModeIcon : darkModeIcon;
  }

  return { 
    colorModeIcon, 
    toggleColorMode 
  };
};
